module.exports = "<p>\n  logout works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/logout/logout.component.html
// module id = ./src/app/auth/logout/logout.component.html
// module chunks = main